import { default as format } from 'date-fns/format'

export default (date) => {
  if(date) {
    return format(date, 'HH:mm:ss')
  }
  return ''
}
